var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tva-breadcrumb"},_vm._l((_vm.content),function(item,listItem){return _c('div',{key:listItem,class:[
      'tva-breadcrumb-item',
      { active: listItem === _vm.content.length - 1 }
    ]},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }